// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const TEMPLATE_INPUT_STEP_SHAPES = [
  {
    stepType: PipelineStepType.TEMPLATE_INPUT,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFrameVariableBinding: {
        kind: 'shape',
        required: false,
        fields: {
          variableId: {
            kind: 'string',
            required: true
          },
          newDataFrameId: {
            kind: 'string',
            required: true
          }
        }
      }
    }
  },
  {
    stepType: PipelineStepType.TEMPLATE_INPUT,
    isDeprecated: false,
    version: 1,
    inputDataShapes: {},
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: null
  },
  {
    stepType: PipelineStepType.TEMPLATE_INPUT,
    isDeprecated: false,
    version: 2,
    inputDataShapes: {},
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      isVariable: {
        kind: 'boolean',
        required: false
      },
      description: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
